import { render, staticRenderFns } from "./ClientEdit.vue?vue&type=template&id=01282460&scoped=true&"
import script from "./ClientEdit.vue?vue&type=script&lang=js&"
export * from "./ClientEdit.vue?vue&type=script&lang=js&"
import style0 from "./ClientEdit.vue?vue&type=style&index=0&id=01282460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01282460",
  null
  
)

export default component.exports